import React from 'react';
import { useHistory } from 'react-router-dom';
import { css, styled, Button, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { imgLinks } from '../../shared';

const StyledBackButtonContainer = styled('div')(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing('1XL')};
  `
);

function BackButton(props) {
  const { label, to, onClick, disabled } = props;

  const intl = useIntl();
  const history = useHistory();

  const displayText =
    label ||
    intl.formatMessage({
      id: 'common.button.back',
    });

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    } else if (to) {
      history.push(to);
    }
  };

  return (
    <StyledBackButtonContainer>
      <Button variant="text" onClick={handleClick} data-testid="back-button" disabled={disabled}>
        <img src={imgLinks['icon.back.arrow']} alt={displayText} />

        <Typography variant="h3">{displayText}</Typography>
      </Button>
    </StyledBackButtonContainer>
  );
}

export default BackButton;

BackButton.propTypes = {
  label: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
